import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { motion } from "framer-motion";
import axios from "axios";

const Aktuelles = () => {

    const [aktuelles, setAktuelles] = useState([]);
    const [isLoading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAllRef = async () => {
            try {
                // Fetch für Aussstattung
                const aktuellesRes = await axios.get(`https://api.augschoell.com/wp-json/wp/v2/aktuelles?per_page=100`);
                if (aktuellesRes.data) {
                    setAktuelles(aktuellesRes.data);
                }

                setLoading(false);
            } catch (err) {
                console.log(err);
            }
        }
        fetchAllRef()
    })

    return (
        <div className="shop">
            <Helmet>
                <title>Shop | Jakob Augschöll</title>
            </Helmet>
            <div className="container">
                <motion.h2
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, ease: "easeOut" }}
                >Shop
                </motion.h2>
                {isLoading ? <div className="loading" /> : aktuelles.map((aktuelles, index) => {
                    const delay = (index % 5) * 0.1;

                    return (
                        <motion.div
                            className="projektContent"
                            key={aktuelles.id}
                            initial={{ opacity: 0, y: 10 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, ease: "easeOut", delay }}
                        >
                            <div className="top">
                                <h2>{aktuelles.title.rendered}</h2>
                                <h3>{aktuelles.acf.date}</h3>
                            </div>
                            <div className="bottom">
                                <div className="wp-content" dangerouslySetInnerHTML={{ __html: aktuelles.content.rendered }} />
                            </div>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    )
};

export default Aktuelles